import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@app/lib/api'

/**
 * The single QueryClient instance. It lives at module level because the route
 * guard (router.tsx `beforeLoad`) reaches the session query from outside the
 * React tree.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      /**
       * A 4xx is the server's final answer — a missing sipNo, a malformed code
       * or an expired session stays missing/malformed/expired however many
       * times we ask, so retrying only delays the error state the user needs to
       * see. Anything else (5xx, network drop) gets exactly one more attempt.
       *
       * This is the whole policy: screens must NOT re-declare it. Before this
       * lived here, three detail screens each carried their own 404/400 guard.
       */
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status <= 499) return false
        return failureCount < 1
      },
    },
  },
})
